import * as stylex from '@stylexjs/stylex';
import '../styles/tokens.stylex';
import { color, spacing } from '../styles/tokens.stylex';
import { typography } from '../styles/typography';
import { layout } from '../styles/layout';
import { PageSectionsContentSectionContentBlocksSolutionCardsSolution } from '@/tina/__generated__/types';
import { RichText } from './RichText';
import { tinaField } from 'tinacms/dist/react';
export interface SolutionListProps {
  data: Solution['data'][];
}
export interface Solution {
  data: PageSectionsContentSectionContentBlocksSolutionCardsSolution;
}
export function SolutionList({
  data
}: SolutionListProps) {
  return data ? <ul className="xrvj5dj x1717udv x1mhrlx8 x131280q x107k3e6 x1bo5odz">
      {data.map((solution, i) => <SolutionCard data={solution} key={i + '-' + solution.need.replace(/\s/, '')} />)}
    </ul> : null;
}
export function SolutionCard({
  data
}: Solution) {
  return data ? <li {...stylex.props([layout.contentCard, styles.solutionCard])}>
      <h2 {...stylex.props([typography.eyebrowSmall, styles.need])}>Need</h2>
      <p {...stylex.props([typography.heading3])} data-tina-field={tinaField(data, 'need')}>
        {data.need}
      </p>
      <h3 {...stylex.props([typography.eyebrowSmall, styles.solution])}>
        Solution
      </h3>
      <div data-tina-field={tinaField(data, 'solution')}>
        <RichText>{data.solution}</RichText>
      </div>
    </li> : null;
}
const styles = {
  solutionCard: {
    kB88ic: "xe8uvvx",
    k1xSpc: "xrvj5dj",
    kOIVth: "xxhr3t",
    kbNqZ1: "x1pte3vf",
    k9llMU: "x1clt5hq",
    $$css: true
  },
  need: {
    kMwMTN: "xjfyra9",
    k1K539: "x1khdm6p",
    $$css: true
  },
  solution: {
    kMwMTN: "xuq06ny",
    k1K539: "x1khdm6p",
    keoZOQ: "x14beivq",
    $$css: true
  }
};